import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "external-services-page p-6" }
const _hoisted_2 = { class: "text-2xl font-bold mb-6 text-white flex items-center justify-between" }
const _hoisted_3 = { class: "flex items-center gap-4" }
const _hoisted_4 = { class: "flex items-center cursor-pointer text-sm font-medium text-gray-300 hover:text-white transition-colors" }
const _hoisted_5 = { class: "bg-gray-800 rounded-lg shadow-lg overflow-hidden border border-gray-700" }
const _hoisted_6 = { class: "overflow-x-auto" }
const _hoisted_7 = { class: "w-full text-left border-collapse" }
const _hoisted_8 = { class: "divide-y divide-gray-700" }
const _hoisted_9 = { class: "p-4 text-gray-300 font-mono" }
const _hoisted_10 = { class: "p-4 text-white font-medium" }
const _hoisted_11 = { class: "p-4" }
const _hoisted_12 = { class: "p-4 text-right" }
const _hoisted_13 = { class: "flex items-center justify-end" }
const _hoisted_14 = { class: "relative inline-flex items-center cursor-pointer" }
const _hoisted_15 = ["onUpdate:modelValue", "onChange"]
const _hoisted_16 = { class: "ml-3 text-sm font-medium text-gray-300 w-8" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, [
      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "flex items-center" }, [
        _createElementVNode("i", { class: "mdi mdi-web mr-3 text-teal-400" }),
        _createTextVNode(" Gestione Web Services ")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("label", _hoisted_4, [
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.showArchived) = $event)),
            class: "mr-2 w-4 h-4 rounded border-gray-600 bg-gray-700 text-teal-500 focus:ring-teal-500 focus:ring-offset-gray-800"
          }, null, 512), [
            [_vModelCheckbox, _ctx.showArchived]
          ]),
          _cache[2] || (_cache[2] = _createTextVNode(" Mostra Archiviati ", -1))
        ]),
        _createElementVNode("button", {
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.testPublicApi && _ctx.testPublicApi(...args))),
          class: "flex items-center gap-2 px-3 py-1.5 bg-teal-500/10 hover:bg-teal-500/20 text-teal-400 rounded text-sm font-medium transition-colors border border-teal-500/20"
        }, [...(_cache[3] || (_cache[3] = [
          _createElementVNode("i", { class: "mdi mdi-open-in-new" }, null, -1),
          _createTextVNode(" Test Public API ", -1)
        ]))])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("table", _hoisted_7, [
          _cache[8] || (_cache[8] = _createElementVNode("thead", null, [
            _createElementVNode("tr", { class: "bg-gray-900 text-gray-400 text-sm uppercase tracking-wider" }, [
              _createElementVNode("th", { class: "p-4 font-semibold border-b border-gray-700" }, " Device ID "),
              _createElementVNode("th", { class: "p-4 font-semibold border-b border-gray-700" }, " Device Name "),
              _createElementVNode("th", { class: "p-4 font-semibold border-b border-gray-700" }, "Status"),
              _createElementVNode("th", { class: "p-4 font-semibold border-b border-gray-700 text-right" }, " Public API ")
            ])
          ], -1)),
          _createElementVNode("tbody", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayedDevices, (device) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: device.id,
                class: "hover:bg-gray-750 transition-colors"
              }, [
                _createElementVNode("td", _hoisted_9, _toDisplayString(device.id), 1),
                _createElementVNode("td", _hoisted_10, _toDisplayString(device.name || "Unnamed Device"), 1),
                _createElementVNode("td", _hoisted_11, [
                  _createElementVNode("span", {
                    class: _normalizeClass([
										'px-3 py-1 rounded-full text-xs font-bold bg-opacity-20 border',
										device.status === 'online'
											? 'bg-green-500 text-green-400 border-green-500'
											: 'bg-red-500 text-red-400 border-red-500',
									])
                  }, [
                    _createElementVNode("i", {
                      class: _normalizeClass([
											'mdi mr-1',
											device.status === 'online'
												? 'mdi-circle-slice-8'
												: 'mdi-alert-circle',
										])
                    }, null, 2),
                    _createTextVNode(" " + _toDisplayString(device.status.toUpperCase()), 1)
                  ], 2)
                ]),
                _createElementVNode("td", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("label", _hoisted_14, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        "onUpdate:modelValue": ($event: any) => ((device.is_public) = $event),
                        class: "sr-only peer",
                        onChange: ($event: any) => (_ctx.togglePublic(device))
                      }, null, 40, _hoisted_15), [
                        [_vModelCheckbox, device.is_public]
                      ]),
                      _cache[5] || (_cache[5] = _createElementVNode("div", { class: "w-11 h-6 bg-gray-600 peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-teal-500 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-teal-500" }, null, -1)),
                      _createElementVNode("span", _hoisted_16, _toDisplayString(device.is_public ? "ON" : "OFF"), 1)
                    ])
                  ])
                ])
              ]))
            }), 128)),
            (_ctx.displayedDevices.length === 0 && !_ctx.loading)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_17, [...(_cache[6] || (_cache[6] = [
                  _createElementVNode("td", {
                    colspan: "4",
                    class: "p-8 text-center text-gray-500"
                  }, " Nessun dispositivo trovato. ", -1)
                ]))]))
              : _createCommentVNode("", true),
            (_ctx.loading)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_18, [...(_cache[7] || (_cache[7] = [
                  _createElementVNode("td", {
                    colspan: "4",
                    class: "p-8 text-center text-gray-400"
                  }, [
                    _createElementVNode("i", { class: "mdi mdi-loading mdi-spin mr-2" }),
                    _createTextVNode(" Caricamento... ")
                  ], -1)
                ]))]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ]))
}